// extracted by mini-css-extract-plugin
module.exports = {"container":"PageError_container__9IR6b"};